import * as ol from 'openlayers';
import {Channel} from '../channel.model';

export class ChannelMarker extends ol.Feature {
  public static readonly SCALE = 0.25;
  public static readonly TYPE_WALL = 'WALL';
  public static readonly TYPE_FLOOR = 'FLOOR';
  public static readonly TYPE_CEILING = 'CEILING';
  static readonly CustomStyleWall = new ol.style.Style({
    image: new ol.style.Icon(({
      anchor: [0.5, 32.0],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      opacity: 1.0,
      scale: ChannelMarker.SCALE,
      src: './assets/images/drawing/wall-channel.png'
    }))
  });

  static readonly CustomStyleFloorCeiling = new ol.style.Style({
    image: new ol.style.Icon(({
      anchor: [0.5, 32.0],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      opacity: 1.0,
      scale: ChannelMarker.SCALE,
      src: './assets/images/drawing/floor-ceiling-channel.png'
    }))
  });

  public label: string;
  public x: any;
  public y: any;
  public stack: number;
  public children: Array<ChannelMarker>;
  public type: string;
  public channel: Channel;

  constructor(x = 0, y = 0, type = ChannelMarker.TYPE_WALL, label: string, coordinateScale: number = 1.0) {
    super({
      geometry: new ol.geom.Point([x * coordinateScale, y * coordinateScale]),
      type: 'Point'
    });
    this.type = type;
    this.label = label;
    this.children = [];

    switch(this.type) {
      case ChannelMarker.TYPE_CEILING:
      case ChannelMarker.TYPE_FLOOR:
        this.setStyle(ChannelMarker.CustomStyleFloorCeiling);
        break;
      case ChannelMarker.TYPE_WALL:
      default:
        this.setStyle(ChannelMarker.CustomStyleWall);
        break;
    }

    this.x = x;
    this.y = y;
    this.stack = 0;
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/drawing/channel-marker.ts